import script from "./SalaryManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaryManagement.vue?vue&type=script&setup=true&lang=js"

import "./SalaryManagement.vue?vue&type=style&index=0&id=07aa3b70&lang=less&scoped=true"
import "./SalaryManagement.vue?vue&type=style&index=1&id=07aa3b70&lang=css"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07aa3b70"]])

export default __exports__